import React from "react";
import { useSelector, useDispatch } from "react-redux";

export default function SubHeader({ header, mainText, noSubHeaderMainText = false }) {
  const { icon, mainWebDisplayText } = useSelector((state) => state.services);

  return (
    <div className="no-padding">
      <div
        className="no-animation cmp-container"
        style={{
          backgroundColor: "#0a6160"
          // backgroundImage: "url(./images/banner-bg-contact-us.svg)",
          // backgroundSize: "cover",
          // backgroundRepeat: "no-repeat"
        }}>
        <div className="aem-Grid aem-Grid--12 aem-Grid--default--12  base-print-grid">
          <div
            className="breadcrumb"
            style={{ ...(noSubHeaderMainText ? { marginBottom: 0 } : {}) }}>
            <div className="cmp-breadcrumb dark-mode" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <nav className="cmp-breadcrumb" aria-label="Breadcrumb">
                <ol className="cmp-breadcrumb__list breadcrumb--default breadcrumb--tablet">
                  <li className="cmp-breadcrumb__item">
                    <a href="/member" className="cmp-button cmp-button--link">
                      <span className="cmp-button__text">Home</span>
                      <span className="icons_space icon-dls-arrow-right"></span>
                    </a>
                  </li>

                  <li className="cmp-breadcrumb__item">
                    <a href={process.env.PUBLIC_URL + "/"} className="cmp-button cmp-button--link">
                      <span className="cmp-button__text">Contact us</span>
                      <span className="icons_space icon-dls-arrow-right"></span>
                    </a>
                  </li>

                  <li className="cmp-breadcrumb__item cmp-breadcrumb__item--active">
                    <span>{header}</span>
                  </li>
                </ol>
                <ol className="cmp-breadcrumb__list breadcrumb--phone">
                  <li className="cmp-breadcrumb__item">
                    <a href={process.env.PUBLIC_URL + "/"} className="cmp-button cmp-button--link">
                      <span className="icons_space icon-dls-arrow-left"></span>
                      <span className="cmp-button__text">Contact Us</span>
                    </a>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
        {!noSubHeaderMainText && (
          <div
            style={{
              display: "flex",
              color: "white",
              fontSize: 40,
              fontWeight: 600,
              justifyContent: "center",
              paddingBottom: 40,
              textAlign: "center"
            }}>
            {" "}
            {/* Main Service Name Big white in the center */}
            {mainText == null ? mainWebDisplayText : mainText}
          </div>
        )}
      </div>
    </div>
  );
}
